'use client';

import { cn } from '@utils';

export const Chip = ({
	leftIcon,
	rightIcon,
	className,
	children,
}: {
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	className?: string;
	children: React.ReactNode;
}) => {
	return (
		<div
			className={cn(
				'border-neutral-lighter flex h-10 items-center gap-2 rounded-full border px-4 py-2',
				className,
			)}
		>
			{leftIcon}
			{children}
			{rightIcon}
		</div>
	);
};
